const es =  {
  sectionTitles: {
    about: "Sobre mí",
    experience: "Experiencia",
    knowledge: "Conocimientos",
    contact: "Contacto"
  },
  aboutMe: `Hola, soy Izam Morales Muñoz, desarrollador full stack. Tengo tres años de experiencia en desarrollo web, dos años de estudios en el área y un año de especialización en inteligencia artificial. Me apasiona crear soluciones innovadoras combinando diseño, funcionalidad y tecnología avanzada. Estoy listo para asumir nuevos retos y seguir creciendo profesionalmente.`,
  experience: {
    begin: {
        title: "El comienzo",
        date: "2022-2023",
        text: "Estudié programación durante dos años en el IES Zaidín Vergeles, donde adquirí conocimientos en diversas tecnologías. Aprendí HTML para la estructura web, Java para la programación orientada a objetos y JavaScript para añadir interactividad. También trabajé con bases de datos, aprendiendo tanto SQL como NoSQL. Durante este tiempo, exploré herramientas como Docker para la contenedorización y el despliegue de aplicaciones, así como PHP y su framework Laravel, lo que me ayudó a desarrollar aplicaciones web de forma eficiente. Finalmente, aprendí a usar WordPress para crear y personalizar sitios web. Este período fue crucial para sentar las bases de mi carrera como programador."
    },
    trainee: {
        title: "Prácticas",
        date: "2023 (Abril - Junio)",
        text: "Durante mis prácticas profesionales de tres meses en Kyndryl, adquirí habilidades clave trabajando en equipo y colaborando en un entorno profesional. Aprendí sobre administración de sistemas Linux, lo que fortaleció mis conocimientos técnicos y desarrollé una aplicación de automatización con Python."
    },
    educa: {
        title: "Desarrollador Junior",
        date: "2023 - 2025",
        text: "Inicié mi carrera profesional en Educa Edtech Group en 2023, donde continúo desarrollándome profesionalmente. Durante este tiempo, he fortalecido notablemente mis habilidades en Java, JavaScript, Git, Python, CSS, VBA para Word y otras herramientas, aplicándolas en proyectos diversos y desafiantes."
    },
    nttdata: {
        title: "Desarrollador Full Stack",
        date: "2025 - Actual",
        text: "Impulsado por mi ambición y mi deseo constante de crecer como desarrollador de software, decidí dar un paso adelante en mi carrera e incorporarme a NTT DATA como desarrollador Full Stack. Actualmente formo parte de un proyecto en el que el backend está desarrollado en Java y el frontend en React. Me siento muy cómodo trabajando con estas tecnologías y mantengo siempre una actitud abierta hacia nuevos retos y oportunidades de aprendizaje.",
    },
    ia: {
        title: "Nuevas habilidades",
        date: "2024 (Octubre - Abril)",
        text: "Completé un curso de especialización de 600 horas en Inteligencia Artificial, en el que adquirí los fundamentos de la inteligencia artificial y el big data. Durante esta formación, entrené y utilicé modelos de inteligencia artificial, realicé procesamiento y análisis de datos, y transformé la información en conclusiones accionables mediante visualizaciones, gráficos y mapas, aplicando estos conocimientos en distintos contextos prácticos.",
    },
  },
  skills: {
    initialMessage: "Haz clic en una habilidad para saber más sobre mi experiencia.",
    js: "Más de 4 años de experiencia desarrollando aplicaciones web escalables y servicios backend con JavaScript y Node.js, priorizando el rendimiento, la mantenibilidad y las buenas prácticas.",
    node: "Más de 2 años de experiencia desarrollando APIs y servicios backend con Node.js, trabajando con arquitecturas escalables, manejo de asincronía y optimización del rendimiento.",
    docker: "Más de 2 años de experiencia contenerizando aplicaciones y servidores con Docker, garantizando entornos consistentes entre desarrollo y producción.",
    mongo: "Más de 2 años de experiencia diseñando esquemas flexibles y gestionando soluciones de almacenamiento de datos de alto rendimiento con MongoDB.",
    python: "Más de 3 años de experiencia desarrollando aplicaciones eficientes con Python, trabajando con data frames, scripts de automatización y modelos de inteligencia artificial.",
    laravel: "1 año de experiencia utilizando Laravel para construir sistemas backend seguros, organizados y escalables siguiendo la arquitectura MVC.",
    r: "1 año de experiencia aplicando R para limpieza de datos, análisis estadístico, modelado predictivo y visualización avanzada de datos.",
    hadoop: "1 año de experiencia trabajando con el ecosistema Hadoop para procesar grandes volúmenes de datos de forma distribuida y eficiente.",
    css: "Más de 4 años de experiencia diseñando interfaces responsivas, modernas y visualmente consistentes utilizando CSS.",
    java: "Más de 4 años de experiencia desarrollando aplicaciones de escritorio robustas y servidores web con Java.",
    react: "2 años de experiencia construyendo aplicaciones web dinámicas y basadas en componentes con React, enfocadas en el rendimiento y la experiencia de usuario.",
    git: "Más de 4 años de experiencia gestionando control de versiones, estrategias de ramificación y flujos de trabajo colaborativos con Git.",
  },
  contact: {
    name: "Nombre",
    email: "Email",
    message: "Mensaje",
    send: "Enviar",
    sending: "Enviando...",
    fieldsError: "Por favor complete todos los campos.",
    nameError: "El nombre debe tener al menos 2 caracteres.",
    emailError: "Introduzca un email válido.",
    messageError: "El mensaje debe tener al menos 10 caracteres.",
    success: "Email enviado correctamente!",
    error: "Error al enviar el correo: "
  },
  footer: {
    explore: "Explorar",
    home: "Inicio",
    legal: "Legal",
    terms: "Términos",
    privacy: "Privacidad",
    cookies: "Cookies",
    email: "Email",
    linkedin: "LinkedIn",
    github: "GitHub",
    copyright: "© 2025 Izam Morales Muñoz, Todos los derechos reservados"
  },
  privacyPolicy: {
    title: "Política de Privacidad",
    lastUpdated: "Última actualización: Enero 2026",
    introduction: "En esta Política de Privacidad se describe cómo se recopilan, utilizan y protegen sus datos personales cuando utiliza este sitio web personal.",
    responsible: {
      title: "1. Responsable del Tratamiento",
      content: "El responsable del tratamiento de sus datos personales es:",
      name: "Izam Morales Muñoz",
      email: "izamm1610@gmail.com"
    },
    dataCollected: {
      title: "2. Datos Recopilados",
      content: "Este sitio web recopila únicamente los siguientes datos personales a través del formulario de contacto:",
      items: [
        "Nombre",
        "Dirección de correo electrónico",
        "Mensaje o consulta"
      ]
    },
    purpose: {
      title: "3. Finalidad del Tratamiento",
      content: "Los datos personales recopilados se utilizan exclusivamente para:",
      items: [
        "Responder a sus consultas y mensajes enviados a través del formulario de contacto",
        "Gestionar la comunicación entre usted y el responsable del sitio web"
      ]
    },
    legalBasis: {
      title: "4. Base Legal",
      content: "El tratamiento de sus datos personales se basa en su consentimiento explícito al enviar el formulario de contacto, de conformidad con el artículo 6.1.a) del Reglamento General de Protección de Datos (RGPD)."
    },
    dataSharing: {
      title: "5. Compartir Datos con Terceros",
      content: "Para el envío de correos electrónicos a través del formulario de contacto, este sitio web utiliza el servicio de EmailJS, un proveedor de servicios de terceros. EmailJS actúa como procesador de datos y está sujeto a sus propias políticas de privacidad.",
      content2: "Sus datos no se comparten con otros terceros para fines comerciales o de marketing. No se realizan transferencias internacionales de datos fuera del Espacio Económico Europeo."
    },
    dataRetention: {
      title: "6. Conservación de los Datos",
      content: "Los datos personales se conservarán únicamente durante el tiempo necesario para cumplir con la finalidad para la que fueron recopilados y, en cualquier caso, durante el tiempo que establezca la legislación aplicable."
    },
    userRights: {
      title: "7. Sus Derechos",
      content: "De conformidad con el RGPD, usted tiene derecho a:",
      items: [
        "Acceder a sus datos personales",
        "Rectificar datos inexactos o incompletos",
        "Solicitar la supresión de sus datos",
        "Oponerse al tratamiento de sus datos",
        "Solicitar la limitación del tratamiento",
        "Portabilidad de los datos",
        "Retirar su consentimiento en cualquier momento"
      ],
      contact: "Para ejercer estos derechos, puede contactar en: izamm1610@gmail.com"
    },
    cookies: {
      title: "8. Cookies",
      content: "Este sitio web puede utilizar cookies técnicas necesarias para el funcionamiento del sitio. No se utilizan cookies de seguimiento o publicitarias."
    },
    security: {
      title: "9. Seguridad",
      content: "Se implementan medidas técnicas y organizativas apropiadas para proteger sus datos personales contra el acceso no autorizado, la pérdida o la destrucción."
    },
    changes: {
      title: "10. Cambios en esta Política",
      content: "Esta Política de Privacidad puede ser actualizada ocasionalmente. Se le notificará cualquier cambio significativo mediante una actualización de la fecha de 'Última actualización' en esta página."
    },
    contact: {
      title: "11. Contacto",
      content: "Si tiene preguntas o inquietudes sobre esta Política de Privacidad o sobre el tratamiento de sus datos personales, puede contactar en:",
      email: "izamm1610@gmail.com"
    },
    backToHome: "← Volver al inicio"
  }
};


export default es;